export const auto_spin = (t) => ({
	AUTOSPIN_HEADER: {
		value: 'AUTOSPIN SETTINGS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	AUTOSPIN_ANIM_TEXT: {
		value: t('autoSpin.skip_animation'),
		config: {
			fill: '#F1E5B5',
			fontSize: '26px',
			fontFamily: 'Poppins SemiBold'
		}
	},
	AUTOSPIN_FAST_TEXT: {
		value: t('autoSpin.fast_spin'),
		config: {
			fill: '#F1E5B5',
			fontSize: '26px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	AUTOSPIN_NUMBEROFSPIN_TEXT: {
		value: t('autoSpin.number_of_spins'),
		config: {
			fill: '#F1E5B5',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	AUTOSPIN_BTN: {
		value: t('autoSpin.start_autospin'),
		config: {
			fill: '#FFFFFF',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	NUMBER_OF_BETS: {
		value: '',
		config: {
			fontFamily: 'Japanese',
			fontSize: 35,
			fill: ['#EF9904', '#dd741d']
		}
	},
	NUMBER_OF_BETS_SELECTED: {
		value: '',
		config: {
			fontFamily: 'Japanese',
			fontSize: 35,
			fill: ['#EF9904', '#dd741d']
		}
	},
	NUMBER_OF_BETS_50: {
		value: '50',
		config: {
			fontName: 'Japanese',
			fontSize: 40,
			letterSpacing: 15
		}
	},
	NUMBER_OF_BETS_50_SELECTED: {
		value: '50',
		config: {
			fontName: 'Japanese',
			fontSize: 40,
			letterSpacing: 15
		}
	},
	NUMBER_OF_BETS_100: {
		value: '100',
		config: {
			fill: '#7571CA',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	NUMBER_OF_BETS_100_SELECTED: {
		value: '100',
		config: {
			fill: '#7BA21C',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	NUMBER_OF_BETS_500: {
		value: '500',
		config: {
			fill: '#7571CA',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	NUMBER_OF_BETS_500_SELECTED: {
		value: '500',
		config: {
			fill: '#7BA21C',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	NUMBER_OF_BETS_1000: {
		value: '1000',
		config: {
			fill: '#7571CA',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	NUMBER_OF_BETS_1000_SELECTED: {
		value: '∞',
		config: {
			fill: '#7BA21C',
			fontSize: '28px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	},
	BTN_NUMBER_OF_BETS: {
		value: '0',
		config: {
			fill: ['#EF9904', '#dd741d'],
			fontSize: '44px',
			fontFamily: 'Japanese',
			align: 'center'
		}
	}
});
